import React from 'react';
import FilterTable from './filterTable';
import {complexColumn} from './tableUtils';

const TemporaryLicenseHistoryTable = props => {
  const columns = [{
    dataField: 'eventDateTime',
    text: 'Event time',
    sort: true,
    filter_: {type: 'datetime'},
    headerStyle: (column, colIndex) => {
      return {width: '18%'}
    }
  }, {
    dataField: 'eventName',
    text: 'Event name',
    sort: true,
    filter_: { type: 'text' },
    headerStyle: (column, colIndex) => {
      return {width: '10%'}
    }
  }, {
    dataField: 'user.login',
    text: 'User',
    sort: true,
    filter_: { type: 'text' },
    headerStyle: (column, colIndex) => {
      return {width: '10%'}
    }
  }, {
    dataField: 'info',
    text: 'Info',
    sort: true,
    filter_: { type: 'text' },
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="temporaryLicensesHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        info: complexColumn(histrec, [{
          fields: 'device.key',
          label: 'Device key'
        }, {
          fields: 'feature.name',
          label: 'Feature'
        }, {
          fields: 'previousValidityTerm',
          label: 'Previous validity term'
        }, {
          fields: 'client.fullName',
          label: 'Client full name',
        }])
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no temporary license history records"
    />
  );
};

export default TemporaryLicenseHistoryTable;



// WEBPACK FOOTER //
// ./src/components/temporaryLicenseHistoryTable.js